import { Resource as i, API as r } from "@coveo/platform-client";
const e = class e extends i {
  /**
   * List MCP Configurations.
   *
   * @param {MCPConfigurationListOptions} options The list options.
   */
  list(t) {
    return this.api.get(this.buildPath(e.baseUrl, t));
  }
  /**
   * Get an MCP Configuration by ID.
   *
   * @param {string} configurationId
   */
  get(t) {
    return this.api.get(`${e.baseUrl}/${t}`);
  }
  /**
   * Create a new basic MCP Configuration.
   *
   * @param {BasicMCPConfigurationModel} basicConfiguration
   */
  createBasic(t) {
    return this.api.post(
      `${e.baseUrl}/create-basic`,
      t
    );
  }
  /**
   * Update an MCP Configuration by ID.
   *
   * @param {string} configurationId
   * @param {Partial<MCPConfigurationModel>} configuration
   */
  update(t, s) {
    return this.api.put(
      `${e.baseUrl}/${t}`,
      s
    );
  }
  /**
   * Delete an MCP Configuration by ID.
   *
   * @param {string} configurationId
   */
  delete(t) {
    return this.api.delete(this.buildPath(`${e.baseUrl}/${t}`));
  }
  /**
   * Set an MCP Configuration as default by ID.
   *
   * @param {string} configurationId
   */
  setAsDefault(t) {
    return this.api.put(
      this.buildPath(`${e.baseUrl}/${t}/set-as-default`)
    );
  }
};
e.baseUrl = `/api/private/organizations/${r.orgPlaceholder}/mcp/configurations`;
let a = e;
export {
  a as MCPConfigurationsResource
};
//# sourceMappingURL=MCPConfigurationsResource.js.map
